import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/Button';
import { SurveyTemplate } from '@/types/database';
import { 
  Download, 
  Upload, 
  UserPlus, 
  ChevronLeft,
  Loader2
} from 'lucide-react';

interface SurveyHeaderProps {
  template?: SurveyTemplate | null;
  uploading?: boolean;
  onDownloadTemplate: () => void;
  onUpload: () => void;
  onAddRespondent: () => void;
  fileInputRef: React.RefObject<HTMLInputElement>;
}

export function SurveyHeader({
  template,
  uploading = false,
  onDownloadTemplate,
  onUpload,
  onAddRespondent,
  fileInputRef
}: SurveyHeaderProps) {
  return (
    <div className="flex flex-col space-y-4">
      <div className="flex items-center space-x-3">
        <Link 
          to="/surveys"
          className="inline-flex items-center text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-300"
        >
          <ChevronLeft className="h-5 w-5" />
          <span className="text-sm">Back to Surveys</span>
        </Link>
      </div>
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-3xl font-semibold text-gray-900 dark:text-white">
            BitBuild Surveys › Respondents
          </h1>
          {template && (
            <p className="text-sm text-gray-500 dark:text-gray-400 mt-1">
              {template.title}
            </p>
          )}
        </div>
        <div className="flex items-center space-x-2">
          <Button
            variant="outline"
            onClick={onDownloadTemplate}
            className="whitespace-nowrap"
          >
            <Download className="h-4 w-4 mr-2 flex-shrink-0" />
            Template
          </Button>
          <Button
            variant="outline"
            onClick={onUpload}
            disabled={uploading}
            className="whitespace-nowrap"
          >
            {uploading ? (
              <>
                <Loader2 className="h-4 w-4 mr-2 flex-shrink-0 animate-spin" />
                Uploading...
              </>
            ) : (
              <>
                <Upload className="h-4 w-4 mr-2 flex-shrink-0" />
                Upload CSV
              </>
            )}
          </Button>
          <input
            ref={fileInputRef}
            type="file"
            accept=".csv"
            onChange={onUpload}
            className="hidden"
          />
          <Button 
            onClick={onAddRespondent}
            className="whitespace-nowrap"
          >
            <UserPlus className="h-4 w-4 mr-2 flex-shrink-0" />
            Add Respondent
          </Button>
        </div>
      </div>
    </div>
  );
}